import { useFormState } from "react-hook-form";
import { FormControl, FormField } from "@/components/ui/form";
import TimeInput from "@/components/TimeInput";

interface TimeInputFieldProps {
  name: string;
}

export const TimeInputField = ({ name }: TimeInputFieldProps) => {
  const { isSubmitting, disabled } = useFormState();

  return (
    <FormField
      name={name}
      render={({ field }) => (
        <FormControl>
          <TimeInput {...field} disabled={isSubmitting || disabled} />
        </FormControl>
      )}
    />
  );
};
